import React from 'react';
import FontAwesome from 'react-fontawesome';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import queryString from 'query-string';

import {dependentDuck, duckify, filterDuck, singleDuck} from 'utils/duckify';
import {customers, modals, paymentPlans, schoolYears } from 'ducks';
import registeredComponent from 'utils/registeredComponent';

import SchoolYearSelect from 'components/SchoolYearSelect';
import history from 'shared_history';
import {stringParams} from 'utils';
import {arrayMove, SortableContainer, SortableElement, SortableHandle} from 'react-sortable-hoc';
import PaymentPlanEditor from './PaymentPlanEditor';
import PaymentPlanScheduleEditor from './PaymentPlanScheduleEditor';
import ModalRoot from '../../ModalRoot';
import ModalComponent from '../../ModalComponent';
import './styles/PaymentPlanList.scss';

class PaymentPlanList extends React.Component {
  render() {
    const {
      customer,
      location,
      onEdit,
      onDelete,
      onReorder,
      onTrackChange,
      paymentPlans,
      schoolYears
    } = this.props;

    const query = queryString.parse(location.search);
    const schoolYearId = query && query.school_year_id || customer.current_enrollment_year.id;
    const schoolYear = schoolYears.filter(schoolYear => schoolYearId === schoolYear.id)[0] || {};
    const billingEnabled = schoolYear && schoolYear.billing_enabled;
    const isArchived = year => year.archived
    const isSelected = year => year.id == schoolYearId
    const dropdownSchoolYears = schoolYears.filter(year => !isArchived(year) || isSelected(year))

    return (
      <div className='payment-plan-list'>
        <ModalRoot modals={{PaymentPlanEditor, PaymentPlanScheduleEditor, PaymentPlanDelete}}/>

        <div className='payment-plan-list-header'>
          <h2 className='inline'>Payment Plans For</h2>
          <SchoolYearSelect
            schoolYearId={schoolYearId}
            onSelect={(year) => onTrackChange(year)}
            schoolYears={dropdownSchoolYears}
          />
        </div>

        <a className={'add-item-button'} onClick={(e) => onEdit(null, schoolYearId)}>
          <FontAwesome name={'plus-circle'}/> Add a new payment plan
        </a>

        <table className='crud-table drag-and-drop table table-align-top table-striped'>
          <thead>
          <tr>
            <th/>
            <th>Active?</th>
            <th>Canonical name</th>
            <th>Default?</th>
            <th>No. of payments</th>
            <th>Has Associated Fee</th>
            <th>Has Schedule</th>
            <th>Last Edit</th>
            <th>Edit History</th>
            <th/>
            <th/>
          </tr>
          </thead>
          <PaymentPlanItemContainer paymentPlans={paymentPlans}
                                    billingEnabled={billingEnabled}
                                    schoolYearId={schoolYearId}
                                    onEdit={onEdit}
                                    onDelete={onDelete}
                                    helperClass="sortable-dragging"
                                    helperContainer={() => document.getElementById('payment-plan-item-container')}
                                    useDragHandle={true}
                                    onSortEnd={
                                      ({newIndex, oldIndex}) => {
                                        onReorder(arrayMove(paymentPlans, oldIndex, newIndex), schoolYearId)
                                      }
                                    }
          />
        </table>
      </div>
    );
  }
}


const PaymentPlanItemContainer = SortableContainer(({paymentPlans, billingEnabled, schoolYearId, onEdit, onDelete}) => (
  <tbody id="payment-plan-item-container">
  {paymentPlans.map((plan, index) => <PaymentPlanItem key={plan.id}
                                                      index={index}
                                                      plan={plan}
                                                      billingEnabled={billingEnabled}
                                                      schoolYearId={schoolYearId}
                                                      onEdit={onEdit}
                                                      onDelete={onDelete}
  />)}
  </tbody>
));


const PaymentPlanItem = SortableElement(({plan, schoolYearId, billingEnabled, onEdit, onDelete}) => (
  <tr data-position-key={`${plan.canonical_name}:${plan.position}`} data-plan-name={plan.canonical_name}>
    <td className="sortable-dragging-visible"><DragHandle/></td>
    <td><input type='checkbox' disabled={true} checked={plan.active} className={'payment-plan-active'}/></td>
    <td className="sortable-dragging-visible">{plan.canonical_name}</td>
    <td><input type='checkbox' disabled={true} checked={plan.is_default} className={'payment-plan-default'}/></td>
    <td>{plan.immediate ? "Due Immediately" : plan.number_of_payments}</td>
    <td>{plan.contract_fees.length !== 0 ? "Yes" : "No"}</td>
    <td className={'has-schedule'}>
      {billingEnabled && (plan.valid_schedules && plan.selectable_schedule
        ? "Yes"
        : (
          <OverlayTrigger
            placement='right'
            overlay={(
              <Tooltip id='tooltip'>
                {!plan.valid_schedules ? 'Plan must have a schedule configured' : 'Because of the ledger lock date, no schedule is currently selectable'}
              </Tooltip>
            )}
          >
            <FontAwesome name='exclamation-triangle red' />
          </OverlayTrigger>
        ))}

      {!billingEnabled && (plan.use_payment_schedule ? "Yes" : "No")}
    </td>
    <td>{I18n.ldate(plan.updated_at)}</td>
    <td><a className={'open-dialog'} href={`/setup/payment_plans/${plan.id}/audit_history`}>View Recent Changes</a></td>
    <td>
      <a className={'payment-plan-edit'}
        href="#"
        onClick={() => {
          onEdit(plan.id, schoolYearId);
          return false;
        }}>
        Edit
      </a>
    </td>
    <td>
      <a className={'payment-plan-delete'}
         href="#"
         onClick={() => {
           onDelete(plan);
           return false;
         }}>Delete</a>
    </td>
  </tr>
));


const DragHandle = SortableHandle(() => <span className="drag-handle">
      <FontAwesome name="reorder"/>
    </span>);


const PaymentPlanDelete = connect()(({dispatch, plan, deleting = false}) => (
  <ModalComponent title="Confirm Delete"
                  buttons={[
                    <button className="btn btn-danger"
                            disabled={deleting}
                            onClick={() => {
                              dispatch(modals.actions.update({deleting: true}));
                              dispatch(paymentPlans.actions.remove(plan))
                                .then(() => dispatch(modals.actions.hide()))
                                .then(() => dispatch(paymentPlans.actions.markDirty()))
                                .catch(() => dispatch(modals.actions.show('UnexpectedError')));
                            }}>{deleting ? 'Deleting...' : 'Delete'}</button>
                  ]}
                  closeText="Cancel">
    <p>Are you sure you want to delete <em>{plan.canonical_name}</em>?</p>
  </ModalComponent>)
);

const mapDucksToProps = (props) => {
  const query = queryString.parse(location.search);
  const customer = singleDuck(customers, 'current');

  return {
    customer,
    schoolYears,
    paymentPlans:
      dependentDuck(
        customer,
        ({value: {current_enrollment_year}}) =>
          current_enrollment_year
            ? filterDuck(paymentPlans, {school_year_id: query && query.school_year_id || current_enrollment_year.id})
            : undefined
      )
  };
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch, props) => ({
  onEdit: (planId, schoolYearId) => {
    dispatch(modals.actions.show('PaymentPlanEditor', {schoolYearId: schoolYearId, planId: planId}));
  },

  onDelete: (plan) => {
    dispatch(modals.actions.show('PaymentPlanDelete', {plan}));
  },

  onReorder: (plans, schoolYearId) => {
    const query = {school_year_id: schoolYearId};
    const stateKey = stringParams(query);
    const ordering = plans.map(p => p.id);

    dispatch(paymentPlans.actions.reorder(ordering, stateKey))
      .catch(() => dispatch(modals.actions.show('UnexpectedError')));
  },

  onTrackChange: (year) => {
    history.push({
      ...props.location,
      search: `?${queryString.stringify({school_year_id: year})}`
    });
  }
});

export default registeredComponent('PaymentPlanList')(
  withRouter(
    duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(
      PaymentPlanList
    )
  )
);
